import { FC } from 'react';

import { Skeleton } from '@/components/atoms/Skeleton/Skeleton';
import { QUESTION_SCHEDULE_ROW_TEST_IDS } from '@/constants/data-testids';

import { TableCell, TableRow } from '../Table/Table';

export const QuestionScheduleRowSkeleton: FC = () => {
  return (
    <TableRow data-testid={QUESTION_SCHEDULE_ROW_TEST_IDS.SKELETON}>
      <TableCell>
        <Skeleton className="h-[14px] w-full mb-1.5" />
        <Skeleton className="h-[14px] w-2/3" />
      </TableCell>
      <TableCell>
        <Skeleton className="h-[14px] w-full" />
      </TableCell>
      <TableCell>
        <Skeleton className="h-[14px] w-full" />
      </TableCell>
      <TableCell>
        <Skeleton className="h-[14px] w-full" />
      </TableCell>
      <TableCell>
        <Skeleton className="h-[14px] w-full" />
      </TableCell>
      <TableCell>
        <Skeleton className="h-[14px] w-full" />
      </TableCell>
      <TableCell>
        <Skeleton className="h-[14px] w-full" />
      </TableCell>
    </TableRow>
  );
};
